export default __webpack_public_path__ + "static/media/v45_60.97371046.png";